import e from"./MenuSelect.vue_vue&type=script&lang.js";import{render as t}from"./MenuSelect.vue_vue&type=template&id=694477eb&lang.js";e.render=t,e.__file="src/components/MenuSelect.vue";export default e;
//# sourceMappingURL=MenuSelect.vue.js.map
